import {
    SkyDataGridColumnDefinition,
} from 'app/shared-components/SkyBaseDataGrid'

import {
    WithId,
} from 'app/types/common.types'

type AdditionalFeesTable = WithId<number> & {
    additionalFeesNumber: string,
    additionalFeesStatus: string,
    validFrom: string,
    validTo: string,
    changedOn: string,
    changedBy: string,
}

const config: SkyDataGridColumnDefinition<AdditionalFeesTable>[] = [
    {
        name: 'additionalFeesNumber',
        labelKey: 'ADDITIONAL_FEE',
    },
    {
        name: 'additionalFeesStatus',
        componentName: 'AdditionalFeesStatusEnriched',
        labelKey: 'STATUS',
    },
    {
        name: 'validFrom',
        componentName: 'DateTimeCell',
        labelKey: 'VALID_FROM',
    },
    {
        name: 'validTo',
        componentName: 'LaneDateEnriched',
        labelKey: 'VALID_TO',
    },
    {
        name: 'changedOn',
        componentName: 'DateTimeCell',
        labelKey: 'CHANGED_ON',
    },
    {
        name: 'changedBy',
        labelKey: 'CHANGED_BY',
    },
]

export default config
